module.exports = __webpack_public_path__ + "media/dashboard/rodzaj-paliwa-8391ec49.svg";